module.exports = {"reprintOrders":"Reprint Orders","makeDonation":"Make a donation","contact":"Contact Us","legal":"Legal/Accessibility","navigationLinks":[{"title":"Client Login","url":"/login","external":false,"subLinks":[]}],"navigationLinks2":[{"title":"Privacy Policy","url":"/privacy-policy","subLinks":[]},{"title":"Terms of Service","url":"/terms","subLinks":[]},{"title":"Accessibility Compliance","url":"/accessibility","subLinks":[]},{"title":"Claims of Copyright","url":"/claims-copyright","subLinks":[]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/PatronNavigation/locales/en.json
// module id = 816
// module chunks = 0